import Modal from "../shared/Modal";
import { Button } from "../../ds2/components";
import "./ModalBasicConfirm.css";
import ActionButton from "./ActionButton";

export type ModalBasicConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  onContinue: () => void;
  continueLabel?: string;
  allowClickout?: boolean;
  allowDismiss?: boolean;
};

const ModalBasicConfirm = ({
  isOpen,
  onClose,
  title,
  message,
  onContinue,
  continueLabel = "Continue",
  allowClickout = true,
  allowDismiss = true,
}: ModalBasicConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={allowDismiss}
        allowClickout={allowClickout}>
        <div id="modal-basic-confirm">
          <div className="modal-basic-confirm-title">{title}</div>

          <div className="modal-basic-confirm-content">{message}</div>

          <div className="modal-basic-confirm-footer">
            <div className="modal-basic-confirm-buttons">
              {allowDismiss && (
                <Button
                  onClick={onClose}
                  variant="secondary"
                >
                  Dismiss
                </Button>
              )}

              <Button
                onClick={onContinue}
                variant="primary"
              >
                {continueLabel}
              </Button>
             
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalBasicConfirm;
